module.exports = __webpack_public_path__ + "static/media/galerija_2021 (32)-min.323d4eb3.jpg";